import { render, staticRenderFns } from "./kindChooseViews.vue?vue&type=template&id=a34ea1e8&scoped=true"
import script from "./kindChooseViews.vue?vue&type=script&lang=js"
export * from "./kindChooseViews.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViews.vue?vue&type=style&index=0&id=a34ea1e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34ea1e8",
  null
  
)

export default component.exports